var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 9.91668C19.4999 9.68591 19.4918 9.45704 19.4757 9.23035L20.1557 9.00369C21.3069 10.3784 22 12.1499 22 14.0833C22 18.4556 18.4556 22 14.0833 22C12.1499 22 10.3785 21.307 9.0037 20.1558L9.23034 19.4758C9.457 19.4919 9.68583 19.5 9.91657 19.5C15.2093 19.5 19.4999 15.2094 19.4999 9.91668Z",
    fill: "#1BA136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11461 7.09167V9.48751H10.2084C11.1563 9.48751 11.9063 9.28959 11.9063 8.27917C11.9063 7.27917 11.1563 7.09167 10.2084 7.09167H9.11461Z",
    fill: "#1BA136"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91669 17.8333C14.289 17.8333 17.8334 14.2889 17.8334 9.91667C17.8334 5.54441 14.289 2 9.91669 2C5.54442 2 2 5.54441 2 9.91667C2 14.2889 5.54442 17.8333 9.91669 17.8333ZM9.11461 13.7661H7.62502V12.6021H6.79168V11.5604H7.62502V10.6958H6.79168V9.48751H7.62502V5.88334H10.1563C12.0834 5.88334 13.4584 6.35209 13.4584 8.27917C13.4584 10.0813 12.0834 10.6958 10.1563 10.6958H9.11461V11.5604H11.4584V12.6021H9.11461V13.7661Z",
    fill: "#1BA136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.39066f77926f1b95161d0a9715290f1e.svg";
export { ForwardRef as ReactComponent };